import { render, staticRenderFns } from "./DutyTypeBar.vue?vue&type=template&id=af4d2430&"
import script from "./DutyTypeBar.vue?vue&type=script&lang=js&"
export * from "./DutyTypeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports